import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Category } from "../../../utils/api/category/category.type";
import Fade from "react-reveal/Fade";
import { Col } from "react-bootstrap";
import { useGetProductListQuery } from "../../../utils/api/product/product.api";
import { ProductItemsSkeleton } from "../../user/ParcoursAchat/ParcoursAchat";
import { AlertInfo } from "../../common/Alert";
import { ProductItem } from "../HomePage";


function ProductsModal({
    show,
    handleClose,
    subCategory,
    category,
}: {
    show: boolean,
    handleClose: () => void,
    subCategory?: Category
    category?: Category
}) {

    const { data = { results: [], count: 0 }, isLoading } = useGetProductListQuery({
        categorie: category?.slug,
        sous_categorie: subCategory?.slug,
        limit: 100,
    });

    return (
        <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton className="">
                <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="title-container">
                    <Fade bottom>
                        <h3 className="title-home-page-theme text-center">
                            {subCategory?.nom}
                        </h3>
                    </Fade>
                </div>
                <div className="pt-3 ">
                    <div className="row">
                        {!!isLoading && <ProductItemsSkeleton />}
                        {!isLoading &&
                            !!data?.results &&
                            data?.results?.length > 0 ? (
                            data?.results?.map((product, index) => (
                                <Col
                                    sm={6}
                                    xs={6}
                                    md={4}
                                    lg={3}
                                    key={index}
                                    className="mb-3"
                                >
                                    <ProductItem
                                        item={product}
                                        key={product?.id}
                                    />
                                </Col>
                            ))
                        ) : (
                            <AlertInfo message="Aucun item" />
                        )}
                    </div>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default ProductsModal;